import { Component, Input, OnInit, input, viewChild } from '@angular/core';
import { ChartComponent, ApexAxisChartSeries, ApexChart, ApexXAxis, ApexYAxis, ApexTitleSubtitle, ApexStroke, ApexPlotOptions, NgApexchartsModule, ChartType } from 'ng-apexcharts';
import { JkBaseComponent } from 'jk-service';
import { jkLib } from 'jk-service';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  title: ApexTitleSubtitle;
  stroke: ApexStroke;
  plotOptions: ApexPlotOptions;
};

@Component({
  selector: 'app-macd-chart',
  standalone: true,
  imports: [NgApexchartsModule],
  templateUrl: './macd-chart.component.html',
  styleUrl: './macd-chart.component.css'
})
export class MacdChartComponent  extends  JkBaseComponent implements OnInit {
  readonly chart = viewChild.required<ChartComponent>('chart');
  //public chartOptions: Partial<ChartOptions>;
  readonly type = input<ChartType>('line');
  readonly height = input<number>(250);
  public chartOptions: ChartOptions = this.setChartOptions();; // Partial<ChartOptions>;
  get XList():string[]{
    return this.itemList.map((item: any) => item.X);
  };
  _itemList: any[] = [];
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() get itemList(): any[] {
    if(!this._itemList) return [];
    return this._itemList;
  }
  set itemList(value: any[]) {
    this._itemList = value;
  }
  constructor() {
    super();
    //this.chartOptions = this.setChartOptions();
  }
  refresh() {
    this.setChartOptions();
  }

  setSeries(): ApexAxisChartSeries {
    let series: ApexAxisChartSeries = [];
    if(this.itemList){
      series = [
      {
        name: 'MACD',
        type: 'line',
        data: this.itemList.map((item: any) => item.macd)
      },
      {
        name: 'DIF',
        data: this.itemList.map((item: any) => item.dif)
      },
      {
        name: 'OSC',
        type: 'bar',
        data: this.itemList.map((item: any) => item.osc)
      },
    ]};
    return series;
  }
  setChartOptions() {
    this.chartOptions = {
      series: this.setSeries(),
      chart: {
        height: this.height(),
        type: this.type(),
      },
      title: {
        text: '', // this.getTitle()
      },
      xaxis: {
        labels: {show: false},
        categories: this.XList
      },
      yaxis: {
        title: {
          text: 'Value'
        }
      },
      stroke: { width: [1, 1, 0] },
      plotOptions: {
        bar: {
          columnWidth: '50%'
        }
      }
    };
    return this.chartOptions;
  }
  getTitle(){
    if((!this.itemList) || (this.itemList.length === 0)) return ''
    else{
      let str = 'K:'+ jkLib.percentStr(this.itemList[this.itemList.length-1].K,2)+' D:'+jkLib.percentStr(this.itemList[this.itemList.length-1].D,2);
      //console.log(str);
      return str;
    }
  }

}
